export default (department: string): string =>
{
    switch (department)
    {
        case 'Cleaning':
            return 'fa-solid fa-spray-can-sparkles';

        case 'Maintenance':
            return 'fa-solid fa-wrench';

        case 'Inspection':
            return 'fa-solid fa-magnifying-glass-location';

        case 'CustomerService':
            return 'fa-solid fa-phone';

        case 'OwnerService':
            return 'fa-solid fa-user';

        default:
            return '';
    }
};
